import { render, staticRenderFns } from "./FormUsuarios.vue?vue&type=template&id=23a1307f"
import script from "./FormUsuarios.vue?vue&type=script&lang=js"
export * from "./FormUsuarios.vue?vue&type=script&lang=js"
import style0 from "./FormUsuarios.vue?vue&type=style&index=0&id=23a1307f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports